import React from 'react';

const Bigtext = () => {
  return (
    <div className="h-auto pb-12 bg-altBack">
      <div className="flex items-center justify-center pt-24 pb-12 ml-12 mr-12 lg:mr-0 lg:ml-0 lg:pt-16 lg:pb-16 font-brand">
        <div className="w-full lg:w-1/2">
          <h3 className="text-2xl font-bold text-center text-gray-800 lg:text-4xl">
            Don’t pay unreasonably high prices for consultancies. Seriously. It’s nothing.
          </h3>
          <p className="pt-5 text-center font-brand">
            Our guide has detailed introductions and walkthroughs for everything. Save money and time. Get 10x the value at x/10th the cost of a
            consultancy.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Bigtext;
